import {
	hideLoadingScreen,
	router,
	setPageContent,
	showLoadingScreen,
} from "..";
import { registerFencealarm } from "../api/users_{userId}_fencealarm";
import { locale } from "../locale";
import { onMobile, scanBarcode } from "../mobile";
import { state } from "../state";
import { objectToQueryString } from "../utils";
import { Bulma } from "../view/bulma";
import { centeredBox } from "../view/components";
import { MaterialDesign } from "../view/material_design";

/**
 * @type {import("navigo").Handler}
 */
function registerFencealarmPage() {
	const scan = () => {
		scanBarcode(
			locale.string({
				enGB: "Scan the IMEI barcode. If the barcode is not recognized, enter the IMEI manually.",
				deDE: "Scannen Sie den IMEI-Strichcode. Wenn der Barcode nicht erkannt wird, geben Sie die IMEI manuell ein.",
				frFR: "Scannez le code-barres IMEI. Si le code-barres n'est pas reconnu, saisissez l'IMEI manuellement.",
				svSE: "Skanna streckkoden för IMEI. Om streckkoden inte känns igen anger du IMEI manuellt.",
			}),
		).then((code) => {
			if (!code) return;
			imei.setValue(code);
		});
	};

	const imei = Bulma.input({
		type: "text",
	});

	const name = Bulma.input({
		type: "text",
	});

	setPageContent(
		centeredBox(
			"small",
			Bulma.level(
				Bulma.levelLeft(
					Bulma.levelItem(
						Bulma.title(
							locale.string({
								enGB: "Register FenceAlarm",
								deDE: "Registrieren FenceAlarm",
								frFR: "Enregistrez FenceAlarm",
								svSE: "Registrera FenceAlarm",
							}),
							"is-4",
						),
					),
				),
				Bulma.levelRight(
					Bulma.levelItem(
						MaterialDesign.icon({
							id: "help",
							onClick: () =>
								window.open(
									locale.string({
										enGB: "https://support.luda.farm/en/support/solutions/folders/14000129703",
										deDE: "https://support.luda.farm/de/support/solutions/folders/14000129703",
										frFR: "https://support.luda.farm/fr/support/solutions/folders/14000129703",
										svSE: "https://support.luda.farm/sv-SE/support/solutions/folders/14000129703",
									}),
									"_blank",
								),
						}),
					),
				),
			),
			Bulma.field(
				{},
				Bulma.label("IMEI"),
				Bulma.field(
					{
						styles: onMobile ? ["has-addons"] : undefined,
					},
					Bulma.control(
						{
							styles: ["is-expanded"],
						},
						imei.element,
					),
					Bulma.control(
						{
							hidden: !onMobile,
						},
						Bulma.button(
							{
								onClick: scan,
							},
							MaterialDesign.icon({
								id: "barcode",
								alignment: "right",
							}),
						),
					),
				),
			),
			Bulma.field(
				{},
				Bulma.label(
					locale.string({
						enGB: "Choose a name for your device",
						deDE: "Wählen Sie einen Namen für Ihr Gerät",
						frFR: "Choisissez un nom pour votre appareil",
						svSE: "Välj ett namn för din enhet",
					}),
				),
				Bulma.control({}, name.element),
			),
			Bulma.field(
				{
					styles: ["is-grouped"],
				},
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: onClickRegister,
							styles: ["is-primary"],
						},
						locale.strings.register,
					),
				),
				Bulma.control(
					{},
					Bulma.button(
						{
							onClick: () => router.jump("/devices/register"),
							styles: ["is-primary"],
						},
						locale.strings.back,
					),
				),
			),
		),
	);

	function onClickRegister() {
		showLoadingScreen();
		registerFencealarm(imei.getValue(), name.getValue())
			.then((fa) => {
				state.fencealarms[fa.Imei] = fa;
				router.jump("/devices" + objectToQueryString({ id: fa.Imei }));
			})
			.finally(hideLoadingScreen);
	}
}

export { registerFencealarmPage };
